export default "__VITE_ASSET__9zJC6xDe__"